<template>
  <div>
    <vx-card>
      <h4 class="mb-5">Filtros</h4>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full">
          <h6 class="mb-2">Representante</h6>
          <v-select
            name="representante"
            label="representante"
            multiple
            v-model="filters.representante"
            :options="getRepresentante">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <h6 class="mb-2">Ordenar por</h6>
          <v-select
            name="orderBy"
            v-model="filters.orderBy"
            :options="[
              { label: 'Valor Total', code: 'valorTotal' },
              { label: 'Última Compra', code: 'ultimaCompra' }
            ]">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
        </div>
      </div>
      <br>
      <div class="flex flex-wrap items-center" slot="footer">
        <vs-button class="mr-6" @click="generateSalePDF()">Gerar PDF</vs-button>
        <vs-button @click="generateSaleXlsx()">Gerar XLSX</vs-button>
      </div>
      <p style="font-style: oblique; font-size: 12px;">Para selecionar todos os resultados, deixe o campo em branco.</p>
      <SalePdf ref="salePdf"></SalePdf>
      <SaleXlsx ref="saleXlsx"></SaleXlsx>
    </vx-card>
  </div>
</template>
<script>
import SalePdf from './SalePdf.vue'
import SaleXlsx from './SaleXlsx.vue'

export default {
  data() {
    return {
      filters: {
        representante: [],
        orderBy: { label: 'Valor Total', code: 'valorTotal' }
      },
    }
  },
  components: {
    SalePdf,
    SaleXlsx
  },
  computed: {
    getRepresentante() {
      return this.getUniquesByColumnAndSort('representante')
    }
  },
  methods: {
    getUniquesByColumnAndSort(column) {
      const orders = this.$store.state.orders
      const results = orders.map(order => order[column])
      const uniqueResults = [...new Set(results)];

      const uniqueResultsSorted = uniqueResults.sort((a, b) => a.localeCompare(b))

      return uniqueResultsSorted
    },
    async generateSalePDF() {
      await this.$refs.salePdf.generate(this.filters)
    },
    async generateSaleXlsx() {
      await this.$refs.saleXlsx.generate(this.filters)
    }
  },
  async created() {
    const payload = {
      loading: this.$vs.loading
    }
    await this.$store.dispatch("fetchOrdersItems", payload)
  },
}

</script>
